import store from '../store'

export default function userHasCompletedData (to, from, next) {
  if (!store.getters['user/hasCompletedTypeData']) {
    return next({
      name: 'first-time-create-profile'
    })
  }

  return false
}
